import { Table } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { qaDataPropTypes } from '../../serialisers/qualityAsssurance';

export function QAInfoView({ hideApprover, qualityAssuranceInfo }) {
  const intl = useIntl();

  const { approvedBy, rejectedBy, uploadedBy } = qualityAssuranceInfo || {};

  const unknown = intl.formatMessage({
    defaultMessage: 'Unknown',
    id: '88183',
  });
  const getDisplayValue = (user) =>
    user?.emailAddress || user?.userId || unknown;

  return (
    <Table>
      <Table.Head>
        <Table.HeaderCell colSpan={2}>
          <FormattedMessage
            defaultMessage="Quality Assurance Information"
            id="e6a93"
          />
        </Table.HeaderCell>
      </Table.Head>
      <Table.Body>
        <Table.Row>
          <Table.DataCell $textAlign="left">
            <FormattedMessage defaultMessage="Uploaded By" id="cc618" />
          </Table.DataCell>
          <Table.DataCell $textAlign="left">
            {getDisplayValue(uploadedBy)}
          </Table.DataCell>
        </Table.Row>
        {!hideApprover && (
          <Table.Row>
            <Table.DataCell $textAlign="left">
              <FormattedMessage defaultMessage="Approved By" id="0f1ca" />
            </Table.DataCell>
            <Table.DataCell $textAlign="left">
              {getDisplayValue(approvedBy)}
            </Table.DataCell>
          </Table.Row>
        )}
        {getDisplayValue(rejectedBy) &&
          getDisplayValue(rejectedBy) !== unknown && (
            <Table.Row>
              <Table.DataCell $textAlign="left">
                <FormattedMessage defaultMessage="Rejected By" id="d3977" />
              </Table.DataCell>
              <Table.DataCell $textAlign="left">
                {getDisplayValue(rejectedBy)}
              </Table.DataCell>
            </Table.Row>
          )}
      </Table.Body>
    </Table>
  );
}

QAInfoView.propTypes = {
  hideApprover: PropTypes.bool,
  qualityAssuranceInfo: PropTypes.shape(qaDataPropTypes).isRequired,
};
QAInfoView.defaultProps = {
  hideApprover: false,
};

export default { QAInfoView };
